import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex flex-col justify-center pt-24 pb-16 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-161">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="space-y-8" data-id="element-162">
        <div className="space-y-4" data-id="element-163">
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3,
          duration: 1
        }} className="flex items-center space-x-4 mb-8" data-id="element-164">
            <div className="h-[1px] w-12 bg-[#d4a853]/50" data-id="element-165" />
            <span className="font-mono text-[#d4a853] text-xs tracking-[0.2em] uppercase" data-id="element-166">
              Reporte Confidencial
            </span>
          </motion.div>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-7xl font-bold text-[#f0c674] leading-[1.1] tracking-tight text-glow" data-id="element-167">
            El Fin del "Cuello de Botella Humano":{' '}
            <br className="hidden md:block" data-id="element-168" />
            <span className="text-gray-100" data-id="element-169">
              Escalá tu Negocio con Micro-Automatización
            </span>
          </h1>

          <h2 className="font-serif text-xl md:text-3xl font-semibold text-[#d4a853]/90 max-w-3xl leading-snug pt-4" data-id="element-170">
            El sistema exacto para dueños de negocio +35 que facturan bien, pero
            ya no tienen vida (y se niegan a contratar empleados caros).
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6,
        duration: 1
      }} className="prose prose-invert max-w-2xl pt-8 border-t border-[#d4a853]/20" data-id="element-171">
          <p className="text-lg md:text-xl text-gray-400 leading-relaxed font-sans" data-id="element-172">
            <strong className="text-gray-200 font-medium" data-id="element-173">
              Son las 11 de la noche de un jueves.
            </strong>{' '}
            Estás frente a la pantalla, con los ojos cansados, pasando datos de
            un Excel a una factura o respondiendo el mismo mensaje de WhatsApp
            por décima vez en el día.
          </p>
          <p className="text-lg md:text-xl text-gray-400 leading-relaxed font-sans mt-4" data-id="element-174">
            Tenés ventas. Tenés clientes. Pero no tenés un negocio... tenés una
            cárcel de cristal donde vos sos el director, el guardia y el único
            prisionero. Si mañana apagás el celular 48 horas, tu facturación se
            detiene en seco. Eso no es libertad, es autoempleo de alto riesgo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.9,
        duration: 0.8
      }} className="pt-8" data-id="element-175">
          <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-176">
            Quiero mi Blueprint Ahora
          </Button>
        </motion.div>
      </motion.div>
    </section>;
}